import apiClient from "../authentication/utils/core/axios";

/**
 * Comment API service
 * This module contains all API calls related to comments
 */
const CommentAPI = {
  /**
   * Create a new comment
   * @param {Object} commentData - The comment data to create
   * @returns {Promise} - The API response
   */
  create: async ({ postId, content, parent_comment_id = null }) => {
    const payload = {
      post_id: postId,      // ✅ required by backend
      content,
    };
    if (parent_comment_id) payload.parent_comment_id = parent_comment_id;

    const response = await apiClient.post('/comments/', payload);
    if (response.status !== 201 && response.status !== 200) {
      throw new Error('Failed to create comment');
    }
    return response.data;
  },


  /**
   * Update an existing comment
   * @param {string} commentId - The ID of the comment to update
   * @param {Object} updatedCommentData - The updated comment data
   * @returns {Promise} - The API response
   */
  update: async (commentId, updatedCommentData) => {
    const response = await apiClient.put(`/comments/${commentId}`, updatedCommentData);
    if (response.status !== 200) {
      throw new Error('Failed to update comment');
    }
    return response.data;
  },

  /**
   * Delete a comment
   * @param {string} commentId - The ID of the comment to delete
   * @returns {Promise} - The API response
   */
  delete: async (commentId) => {
    const response = await apiClient.delete(`/comments/${commentId}`);
    if (response.status !== 204) {
      throw new Error('Failed to delete comment');
    }
    return commentId;
  },

  /**
   * Like a comment
   * @param {string} commentId - The ID of the comment to like
   * @returns {Promise} - The API response
   */
  like: async (commentId) => {
    const response = await apiClient.post(`/comments/${commentId}/like`);
    return response.data;
  },

  /**
   * Unlike a comment
   * @param {string} commentId - The ID of the comment to unlike
   * @returns {Promise} - The API response
   */
  unlike: async (commentId) => {
    const response = await apiClient.delete(`/comments/${commentId}/like`);
    return response.data;
  }
};

export default CommentAPI;